const bounceableRoutes = [
    '/donation/details',
    '/volunteer/form',
    '/email',
    '/email/multiRepStep2',
    '/petition',
    '/petition/start',
    '/voteRegistration/step1',
    '/voteRegistration/step2',
    '/voteRegistration/step3',
    '/voteRegistration/step4',
    '/voteRegistration/step5',
    '/voteRegistration/step6',
    '/voteRegistration/step7',
    '/voteRegistration/step8'
];

export const isBounceableRoute = route => bounceableRoutes.includes(route);
